import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatCurrency } from 'syf-js-utilities';
import Stack from 'syf-component-library/ui/spacing/Stack/Stack';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { CustomContainer, NormalText, TextContainer, Title } from './subcomponents';
const CreditLimitDetails = ({ creditLimitAmount, displayText }) => {
    const creditLimitFormatted = formatCurrency(creditLimitAmount);
    return (_jsx(CustomContainer, { children: _jsx(Inset, { horizontal: "large", children: _jsxs(TextContainer, { children: [_jsx(Title, { children: creditLimitFormatted }), _jsx(Stack, { size: "xsmall" }), _jsx(NormalText, { children: displayText })] }) }) }));
};
export default CreditLimitDetails;
